import { useTranslation } from 'react-i18next'

import { ReactComponent as Edit } from '../../../assets/icons/pencil.svg'
import { ReactComponent as Delete } from '../../../assets/icons/trash.svg'
import { useUsersStore } from '../../../stores/usersStore'
import { IRoleEnum } from '../../../types/router'
import { getRole } from '../../../utils/auth'

import styles from '../User/user.module.scss'
interface IUserProps {
    name: string
    id: string
    email: string
    role: IRoleEnum
    startEditing: () => void
}

function UserContent(props: IUserProps) {
    const { id, name, email, role, startEditing } = props

    const { t } = useTranslation()

    const [, { deleteUser }] = useUsersStore()

    const handleDeleteUser = () => {
        deleteUser(id)
    }

    return (
        <>
            <div className={styles.user__data}>
                <div className={styles.user__text}>{name}</div>
                <div className={styles.user__text}>{email}</div>
                <div className={styles.user__text}>{getRole(role)}</div>
            </div>
            <div className={styles.user__buttons}>
                <button className={styles.user__btn} onClick={startEditing}>
                    <Edit className={styles.user__icon} alt={t('edit')} />
                </button>
                <button className={styles.user__btn} onClick={handleDeleteUser}>
                    <Delete className={styles.user__icon} alt={t('delete')} />
                </button>
            </div>
        </>
    )
}

export default UserContent
